module.exports = __webpack_public_path__ + "img/gift_3.6378af5f.png";